import defineComponent from 'flight';
import searchIdStorage from 'static/script/app/data/searchid';
import ItemsClickStorage from 'static/script/app/models/items-click-storage';

function ItemCardsUI() {
    this._storage = new ItemsClickStorage();

    this.defaultAttrs({
        itemCardBody: '[data-item-card-body]',
        itemLink: '[data-item-link]',
        searchIdDataAttribute: 'search-id'
    });

    this._itemBodyClick = function(evt, listener) {
        let target = $(evt.target),
            el = $(listener.el),
            itemLink = el.find(this.attr.itemLink);

        let searchId = el.data(this.attr.searchIdDataAttribute);
        let itemId = el.parent().data('item-id');

        if (searchId && itemId) {
            this._storage.add({
                itemId: itemId,
                searchId: searchId
            });

            searchIdStorage.set(searchId);
        }

        let isLinkOrInsideLink = function(element) {
            if (element.is('a') || element.parents('a').length > 0) {
                // Extend this with button, input etc if/when needed
                return true;
            }
            return false;
        };

        if (!isLinkOrInsideLink(target) && itemLink.length > 0) {
            itemLink.trigger('click');
        }
    };

    this.after('initialize', function() {
        this.on('click', {
            itemCardBody: this._itemBodyClick
        });
    });
}

export default defineComponent.component(ItemCardsUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/item-cards-ui.js